import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";

import { Dropdown } from "@/features/common/components/Dropdown";
import { IconButton } from "@/features/common/components/IconButton";
import {
  DEFAULT_ITEMS_PER_PAGE,
  usePaginationContext,
} from "@/features/common/contexts/usePaginationContext";

const itemsPerPageOptions = [DEFAULT_ITEMS_PER_PAGE, 36, 48];

export const ItemsPerPageSelector = () => {
  const { itemsPerPage, onItemsPerPageChange } = usePaginationContext();

  return (
    <Dropdown
      button={({ open }) => (
        <IconButton className="flex w-max items-center text-base font-light text-gray-900">
          <span>每頁顯示{itemsPerPage}個</span>
          <div className="text-gray-500">
            {!!open ? (
              <ChevronUpIcon className="h-5 w-5" />
            ) : (
              <ChevronDownIcon className="h-5 w-5" />
            )}
          </div>
        </IconButton>
      )}
      options={itemsPerPageOptions.map((value) => ({
        name: `每頁顯示${value}個`,
        selected: itemsPerPage === value,
        onClick: () => onItemsPerPageChange(value),
      }))}
    />
  );
};
